import { render, staticRenderFns } from "./content-footer.vue?vue&type=template&id=3b39c04c&scoped=true&"
import script from "./content-footer.vue?vue&type=script&lang=js&"
export * from "./content-footer.vue?vue&type=script&lang=js&"
import style0 from "./content-footer.vue?vue&type=style&index=0&id=3b39c04c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39c04c",
  null
  
)

export default component.exports